export default __webpack_public_path__ + "static/media/mobile_reward1_detail_1.3ee2f346.png";